import { Component } from "react"

import User from "../../libs/user/User"

import { FisicaType, FisicaState, PeopleProps, getPeopleAddress } from "./PeopleSlice"
import { Person } from "../../libs/user/Person"

import { authFetch } from "../../libs/cookie/Cookie"
import { FERTCH_USERE_DATA_URL } from "../../costants"

import { isEmpty } from "../../libs/validation/stringRegex"

type GenericType = FisicaType
interface GenericProps extends PeopleProps<GenericType> {}

class People <P extends GenericProps, S extends FisicaState> extends Component<P,S> {

    // da sovrascrivere
    getStateAsContractor () {
        const addres = getPeopleAddress (
            this.state.street,
            this.state.street_number,
            this.state.zip,
            this.state.city,
            this.state.indirizzoResidenza_SedeLegale
        )

        return {
                tipoPersona: this.state.tipoPersona,
                nome: this.state.nome,
                cognome: this.state.cognome,
                email: this.state.email,
                cellulare: this.state.cellulare,

                indirizzoResidenza_SedeLegale: addres,
                street: this.state.street,
                street_number: this.state.street_number,
                zip: this.state.zip,
                city: this.state.city,

                is_manual_address: this.state.is_manual_address,

                sesso: this.state.sesso,
                data_nascita: this.state.data_nascita,
                natoInItalia: this.state.natoInItalia,
                stato_nascita: this.state.stato_nascita,
                comune_nascita: this.state.comune_nascita,
                professione: this.state.professione,
                
                selectPeopleId: this.state.selectPeopleId
            }
    }
        
    // comuni --->

    // setters
    updateEmail (val: string | undefined) {
        this.setState(
            {
                email: val,
                emailError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateCellulare (val: string | undefined) {
        this.setState(
            { 
                cellulare: val,
                cellulareError: undefined
             },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }

    updateName (val: string | undefined) {
        this.setState(
            { 
                nome: val,
                nomeError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateCognome (val: string | undefined) {
        this.setState(
            { 
                cognome: val,
                cognomeError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }

    updateNatoInItalia (val: boolean | undefined){
        this.setState(
            { 
                natoInItalia: val,
                comune_nascita: (val === false) ? undefined : this.state.comune_nascita,
                natoInItaliaError: undefined,
                stato_nascitaError: undefined,
                comune_nascitaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateSesso (val: number | undefined) {
        this.setState(
            { 
                sesso: val,
                sessoError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateData_nascita (val: string | undefined) {
        this.setState(
            { 
                data_nascita: val,
                data_nascitaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateStato_nascita (val: number | undefined) {
        this.setState(
            { 
                stato_nascita: val,
                comune_nascita: undefined,
                stato_nascitaError: undefined,
                comune_nascitaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateComune_nascita (val: string | undefined) {
        this.setState(
            { 
                comune_nascita: val,
                stato_nascita: 13,
                comune_nascitaError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }
    updateProfessione (prof: string) {
        this.setState(
            {
                professione: prof,
                professioneError: undefined
            },
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )
    }

    updateIndirizzo (val: string) {
        this.setState(
            {
                indirizzoResidenza_SedeLegale: val,
                indirizzoError: undefined
            },
            () => {
                this.props.updatePeopleCallback (
                    this.getStateAsContractor()
                )
            }
        )
    }
    setIndirizzo () {
        let nextAddress : any = {
            indirizzoResidenza_SedeLegale: undefined,
            indirizzoError: undefined
        }

        if (
                !isEmpty(this.state.street) &&
                !isEmpty(this.state.street_number) &&
                !isEmpty(this.state.zip) &&
                !isEmpty(this.state.city)
        ) {
            const completeAddress = this.state.street + ', ' +
                this.state.street_number + ', ' +
                this.state.zip + ' ' +
                this.state.city + ', ITALIA'

            nextAddress = {
                ...nextAddress,
                ...{indirizzoResidenza_SedeLegale: completeAddress}
            }
        }

        this.setState (
            nextAddress,
            () => {
                this.props.updatePeopleCallback(
                    this.getStateAsContractor()
                )
            }
        )

    }
    updateStreet (val: string | undefined) {
        this.setState({
            street: val?.toUpperCase(),
            streetError: undefined
        }, () => {
            this.setIndirizzo()
        })
    }
    updateStreet_number (val: string | undefined) {
        this.setState({
            street_number: val,
            street_numberError: undefined
        }, () => {
            this.setIndirizzo()
        })
    }
    updateZip (val: string | undefined) {
        this.setState({
            zip: val,
            zipError: undefined
        }, () => {
            this.setIndirizzo()
        })
    }
    updateCity (val: string | undefined) {
        this.setState({
            city: val,
            cityError: undefined
        }, () => {
            this.setIndirizzo()
        })
    }
    updateAllAddressParts(
        pStreet: string | undefined | null,
        pStreet_number: string | undefined | null,
        pZip: string | undefined | null,
        pCity: string | undefined | null
    ) {
        this.setState({
            street: (pStreet === null) ? undefined : pStreet?.toUpperCase(),
            street_number: (pStreet_number === null) ? undefined : pStreet_number,
            zip: (pZip === null) ? undefined : pZip,
            city: (pCity === null) ? undefined : pCity,

            indirizzoError: undefined,
            streetError: undefined,
            street_numberError: undefined,
            zipError: undefined,
            cityError: undefined
        }, () => {
            this.setIndirizzo()
        })
    }

    updateIsManualAddress ( val: boolean) {
        this.setState({
            is_manual_address: val
        }, () => {
            this.props.updatePeopleCallback(
                this.getStateAsContractor()
            )
        })
    }

    updateSelectedPeople (propsId: string | undefined) {
        if (propsId === undefined && this.state.selectPeopleId !== undefined) {
            this.setState({
                selectPeopleId: undefined,
                selectPeopleIdError: undefined
            })
        }
    }

    updateUserData (user?: User) {
        if (user) {
            if (this.props.updateUserCallBack) {
                this.props.updateUserCallBack (
                    user
                )
            }
        } 
        else {
            authFetch (
                FERTCH_USERE_DATA_URL,
                {
                    method: "get"
                },
                this.manageExpiredSession
            )
            .then ( jsonObj => {
                if (
                    jsonObj?.success !== false &&
                    this.props.updateUserCallBack
                ) {
                
                    this.props.updateUserCallBack (
                        new User ( jsonObj )
                    )

                }
            })
            .catch( error => {
                if (
                    error === 'TOKEN_EXPIRED' &&
                    this.props.updateUserCallBack
                ) {
                    this.props.updateUserCallBack (undefined)
                }
            })
        }
    }

    // getters
    getValueForGender (g: string | undefined) {
        return (g === undefined || g === '')
            ? undefined
            : (g === 'uomo') ? 0 : 1
    }
    getValueForCountry (p : Person) {
        return (p.bornInItaly === true)
            ? 13
            : Number (p.countryOfBirth?.id)
    }

    // gestione sessione
    manageExpiredSession () {
        this.setState({
            selectPeopleId: undefined
        }, () => {
            if (this.props.expiredSessionCallbak !== undefined) {
                this.props.expiredSessionCallbak(true)
            }
            else if (this.props.updateUserCallBack !== undefined) {
                this.props.updateUserCallBack()
            }
        })
    }

    // enums
    updateProfList (profs: any) {
        this.setState({
            profList: profs
        })
    }
    updateSessoList (sex: any) {
        this.setState({
            sessoList: sex
        })
    }
    updateStatiList (stati: any) {
        this.setState({
            statiList: stati
        })
    }

    // gestione errori
    clearNomeError () {
        this.setState({
            nomeError: undefined
        })
    }
    clearCognomeError () {
        this.setState({
            cognomeError: undefined
        })
    }
    clearEmailError () {
        this.setState({
            emailError: undefined
        })
    }
    clearCellulareError () {
        this.setState({
            cellulareError: undefined
        })
    }
    clearNatoInItaliaError () {
        this.setState({
            natoInItaliaError: undefined
        })
    }
    clearSessoError () {
        this.setState({
            sessoError: undefined
        })
    }
    clearData_nascitaError () {
        this.setState({
            data_nascitaError: undefined
        })
    }
    clearStato_nascitaError () {
        this.setState({
            stato_nascitaError: undefined
        })
    }
    clearComune_nascitaError () {
        this.setState({
            comune_nascitaError: undefined
        })
    }
    clearIndirizzoError () {
        this.setState({
            indirizzoError: undefined
        })
    }
    clearStreetError () {
        this.setState({
            streetError: undefined
        })
    }
    clearStreet_numberError () {
        this.setState({
            street_numberError: undefined
        })
    }
    clearZipError () {
        this.setState({
            zipError: undefined
        })
    }
    clearCityError () {
        this.setState({
            cityError: undefined
        })
    }
    clearProfessioneError () {
        this.setState({
            professioneError: undefined
        })
    }
    clearselectPeopleIdError () {
        this.setState({
            selectPeopleIdError: undefined
        })
    }

}

export default People